// src/Components/aws-config.js

const awsConfig = {
    region: "us-east-2",  // Example: Ohio AWS region
    accessKeyId: "AKIA356SJZPTXPITCL6U",
    secretAccessKey: "KV0dSP4zjZe0Fv188k+cbxwMX9d2XpUNOxJFi3pJ",
    tableName: "DiscoverTransaction" // (Or whatever your DynamoDB table name is)
  };

  export default awsConfig;
